"use strict";

exports.__esModule = true;
exports.Schema = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
var _errors = require("../common/errors");
const Schema = exports.Schema = {
  make: ({
    id = '',
    fields = {}
  } = {}) => ({
    id,
    fields
  }),
  makeField: ({
    type = 'text',
    referencedCollection
  } = {}) => ({
    type,
    referencedCollection
  }),
  getFieldType: (schema, fieldKey) => getFieldSchema(schema, fieldKey).type,
  getReferencedFieldType: (schema, schemas, {
    fieldKey,
    referencedFieldKey
  }) => {
    const referencedCollectionId = Schema.getReferencedCollectionId(schema, fieldKey);
    const referencedSchema = schemas.find(({
      id
    }) => id === referencedCollectionId);
    if (referencedSchema === undefined) {
      throw _errors.CoreError.of('Referenced schema not found');
    }
    return Schema.getFieldType(referencedSchema, referencedFieldKey);
  },
  getReferencedCollectionIds: schema => {
    const uniqueIds = Object.entries(schema.fields).reduce((acc, [_, {
      referencedCollection
    }]) => referencedCollection ? acc.add(referencedCollection) : acc, new Set());
    return Array.from(uniqueIds);
  },
  getReferencedCollectionId: (schema, fieldKey) => getFieldSchema(schema, fieldKey).referencedCollection,
  isFieldOfType: (schema, fieldKey, type) => {
    const fieldType = Schema.getFieldType(schema, fieldKey);
    return fieldType === _wixDataSchemaTypes.FieldType[type];
  }
};
const getFieldSchema = (schema, fieldKey) => schema.fields[fieldKey] ?? {};
//# sourceMappingURL=schema.js.map